import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentPlatformService } from 'src/app/services/current-platform/current-platform.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadAppGuard implements CanLoad {

  constructor(
    private router: Router,
    private currentPlatformService: CurrentPlatformService
  ){}


  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    // if browser them move to load-app page untill complete app for browser.
    if(this.currentPlatformService.isBrowser()){
      this.router.navigateByUrl('/download-app');
      return false;
    } else return true
  }
}
